export const Logo = ({ size = "md" }) => {
  const dim = size === "sm" ? "w-9 h-9" : "w-11 h-11";
  return (
    <div className="flex items-center gap-3" data-testid="jv-logo">
      <img
        src="/logo.png?v=2"
        alt="Justice Verse"
        className={`jv-logo-img ${dim} object-contain shrink-0`}
      />
      <div className="font-serif text-xl sm:text-2xl tracking-[0.18em] text-ink whitespace-nowrap">
        JUSTICE VERSE
      </div>
    </div>
  );
};

export default Logo;
